import axios, { AxiosInstance } from "axios";
import config from "../config.json";
const requestToApi: AxiosInstance = axios.create({
  baseURL: config.mode === "test" ? config.urls.test : config.urls.prod,
  // for deployment use: https://flaskapi.ip-pbx.eu/
});

export default requestToApi;
